import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiGlobe, FiMapPin, FiCpu } from 'react-icons/fi';

const SEOIntro = () => {
  return (
    <section className="mb-16">
      <motion.div 
        initial={{ opacity: 0, y: 20 }} 
        animate={{ opacity: 1, y: 0 }}
        className="space-y-6"
      >
        <div className="flex items-center gap-3 text-blue-600 dark:text-blue-400 font-bold uppercase tracking-[0.2em] text-[10px]">
          <SafeIcon icon={FiGlobe} />
          <span>Global Metabolic Standard v2.1</span>
        </div>
        
        <h1 className="text-5xl md:text-7xl font-black tracking-tighter leading-none dark:text-white">
          The Science of <br />
          <span className="text-blue-600 italic">Metabolic Intelligence.</span>
        </h1>
        
        <div className="prose prose-lg dark:prose-invert max-w-none">
          <p className="text-xl text-gray-600 dark:text-gray-400 leading-relaxed font-medium">
            Welcome to the <strong>TDEE Intelligence Lab</strong>, the premier digital destination for precision metabolic engineering. Whether you are in New York, London, or Tokyo, our platform provides localized health intelligence tailored to your unique physiological profile. 
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12">
            <div className="bg-white dark:bg-gray-800 p-6 rounded-2xl border border-gray-100 dark:border-gray-700 shadow-sm">
              <h3 className="text-lg font-bold mb-3 flex items-center gap-2">
                <SafeIcon icon={FiCpu} className="text-blue-600" />
                AI-Ready Data
              </h3>
              <p className="text-sm text-gray-500">Our engine uses the Mifflin-St Jeor equation, recognized globally by clinical nutritionists as the gold standard for non-obese and obese populations alike.</p>
            </div>
            <div className="bg-white dark:bg-gray-800 p-6 rounded-2xl border border-gray-100 dark:border-gray-700 shadow-sm">
              <h3 className="text-lg font-bold mb-3 flex items-center gap-2">
                <SafeIcon icon={FiMapPin} className="text-blue-600" />
                Geo-Optimized
              </h3>
              <p className="text-sm text-gray-500">Supporting both Metric and Imperial units, we cater to fitness enthusiasts worldwide, ensuring no conversion errors in your metabolic blueprint.</p>
            </div>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default SEOIntro;